import Vue from 'vue'
let vm = {
  delimiters: ['{', '}'],
  model: {    // 使用model， 这儿2个属性，prop属性说，我要将msg作为该组件被使用时（此处为aa组件被父组件调用）v-model能取到的值，event说，我emit ‘cc’ 的时候，参数的值就是父组件v-model收到的值。
      prop: 'parentProp',
      event: 'parentEvent'
    },
  props: {
    parentProp:{
      type: [Array, String]
    },
    options: Array,
    type:String,

  },
  data: () => {
    return {
      type_str:["varchar","文本","str", "String"],
      type_num:["整数","数值","decimal","int", "number"],
      type_bool:["boolean","bool","布尔"],
      type_time:["date","time","datetime"],
      type_select:["select"],
      type_rating:["rating"],
      input_rating:null,
      start_score:null,
      end_score:null,
      input_bool:null,
      input_str: null,
      start_num: null,
      end_num: null,
      start_date: null,
      end_date: null,
      input_select: null,
      endOpen: false,
      vxe_options: ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC', 'CC', 'C']
    }
  },
  computed: {

  },
  methods: {
    selectOnChange(valueObj) {
      let value_list = valueObj.value
      let last_value = value_list[value_list.length - 1] 
      // 判断当前选的是全部
      if(!last_value) {
        valueObj.value=[last_value]
        this.input_rating = [last_value]
      } else {
        // 如果当前不是全部，判断已选择中有无全部，若有则取消全部
        for(let i =0;i < value_list.length -1; i++) {
          if(!value_list[i]){
            value_list.splice(i,1)
            valueObj.value = value_list
            this.input_rating = value_list
          }
        }
      }
    },
    checkStartNum(){
      this.start_num = parseFloat(this.start_num)
     //  if(typeof this.start_num !== 'number' || isNaN(this.start_num)){
     // this.start_num = 0
     //  }
     //  if(this.start_num && this.end_num && this.start_num > this.end_num){
     //    this.start_num = 0
     //  }
    },
    checkEndNum(){
      this.end_num = parseFloat(this.end_num)
     //  if(typeof this.end_num !== 'number' || isNaN(this.end_num)){
     // this.end_num = 0
     //  }
     //  if(this.start_num && this.end_num && this.start_num > this.end_num){
     //    this.end_num = 0
     //  }
    },
  disabledStartDate(start_date) {
      const end_date = this.end_date;
      if (!start_date || !end_date) {
        return false;
      }
      return start_date.valueOf() > end_date.valueOf();
    },
    disabledEndDate(end_date) {
      const start_date = this.start_date;
      if (!end_date || !start_date) {
        return false;
      }
      return start_date.valueOf() >= end_date.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
  },
  mounted () {

  },
  watch: {
    input_rating:function () {
      if(this.type_rating.indexOf(this.type)!=-1){
          this.$emit('parentEvent', this.input_rating)
      }
    },
    start_score: function () {
      if(this.type_rating.indexOf(this.type)!=-1){
          this.$emit('parentEvent', {'start':this.start_score,'end':this.end_score})
      }
    },
    end_score: function () {
      if(this.type_rating.indexOf(this.type)!=-1){
          this.$emit('parentEvent', {'start':this.start_score,'end':this.end_score})
      }
    },
    input_str: function () {
      if(this.type_num.indexOf(this.type)!=-1){
          this.$emit('parentEvent', this.input_str)
      }
    },
    input_select: function () {
      if(this.type_select.indexOf(this.type)!=-1){
          this.$emit('parentEvent', this.input_select)
      }
    },
    start_num: function () {
      if(this.type_num.indexOf(this.type)!=-1){
          this.$emit('parentEvent', {'start':this.start_num,'end':this.end_num})
      }
    },
    end_num: function () {
      if(this.type_num.indexOf(this.type)!=-1){
          this.$emit('parentEvent', {'start':this.start_num,'end':this.end_num})
      }
    },
    start_date: function () {
      if(this.type_time.indexOf(this.type)!=-1){
          this.$emit('parentEvent', {'start':this.start_date,'end':this.end_date})
      }
    },
    end_date: function () {
      if(this.type_time.indexOf(this.type)!=-1){
          this.$emit('parentEvent', {'start':this.start_date,'end':this.end_date})
      }
    },
    input_bool: function () {
      if(this.type_bool.indexOf(this.type)!=-1){
          this.$emit('parentEvent', {'start':this.start_date,'end':this.end_date})
      }
    },
  }
}
Vue.component('input-filter', vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/input_filter.js